module.exports = "<app-navigation></app-navigation>\n\n<router-outlet></router-outlet>\n"